import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import {
	formatVariluxGoalsPayload,
	formatVariluxGoalsResponse,
	validateVariluxGoalsPayload
} from "../../utils/varilux-goals-utils";
import { hasValidationErrors } from "../../../utils/validation-utils";

export function useVariluxGoalsUpdate() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [validationErrors, setValidationErrors] = useState({});

	const validateVariluxGoals = values => {
		const errors = validateVariluxGoalsPayload(values);

		setValidationErrors(errors);

		return errors;
	};

	async function updateVariluxGoals(segmentationId, variluxGoalsId, payloadData) {
		const valuesToValidate = {
			...payloadData,
			segmentation: segmentationId
		};

		const errors = validateVariluxGoalsPayload(valuesToValidate);

		if (hasValidationErrors(errors)) {
			setValidationErrors(errors);
			setError(null);

			return {
				ok: false,
				reason: "validation",
				validationErrors: errors
			};
		}

		if (!variluxGoalsId) {
			const idError = {
				variluxGoalsId: "Não foi possível identificar a meta Varilux."
			};

			setValidationErrors(idError);
			setError(null);

			return {
				ok: false,
				reason: "validation",
				validationErrors: idError
			};
		}

		try {
			setLoading(true);
			setError(null);
			setValidationErrors({});

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const body = formatVariluxGoalsPayload(payloadData);

			const requestOptions = {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				},
				body: JSON.stringify(body)
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/segmentacoes/${encodeURIComponent(segmentationId)}/varilux/${encodeURIComponent(variluxGoalsId)}`,
				requestOptions
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível editar a meta Varilux."
				);
			}

			const data = await response.json();

			const variluxGoalsData = Array.isArray(data.resultado)
				? data.resultado[0]
				: data.resultado || data;

			const formattedVariluxGoals = formatVariluxGoalsResponse(variluxGoalsData);

			return {
				ok: true,
				variluxGoals: formattedVariluxGoals
			};
		} catch (requestError) {
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		loading,
		error,
		validationErrors,
		validateVariluxGoals,
		updateVariluxGoals
	};
}